import React from 'react';
import { useRecordContext } from 'react-admin';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

const CourseVersionLinkFieldContainer = styled('div')({
  marginTop: 12,
  marginBottom: 4,
});

const Label = styled('label')({
  color: 'grey',
  fontSize: 12,
  fontFamily: ['"Roboto"', '"Helvetica"', '"Arial"', 'sans-serif'],
  lineHeight: 1,
  textTransform: 'capitalize',
});

const Link = styled('a')({
  color: '#3f51b5',
  fontSize: 14,
  fontFamily: ['"Roboto"', '"Helvetica"', '"Arial"', 'sans-serif'],
  textDecoration: 'none',
  lineHeight: 1,
});

const CourseVersionLinkField = ({ source }) => {
  const record = useRecordContext();

  return (
    <CourseVersionLinkFieldContainer>
      <Label>
        <span>{source} &nbsp; </span>
      </Label>
      <Link href={`#/CourseVersion/${record.id}/show`}>{record[source]}</Link>
    </CourseVersionLinkFieldContainer>
  );
};

CourseVersionLinkField.propTypes = {
  label: PropTypes.string,
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
};

export default CourseVersionLinkField;
